import PrivateRoute from './PrivateRoute';
import "eksenia-lib/src/PrivateLayout/PrivateLayout.scss"

export default PrivateRoute;
